'use es6';

import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { DragLayer } from 'react-dnd-compat';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import MenuRootPreview from 'simple-menus-lib/components/dnd/preview/MenuRootPreview';
import { EARTH_LAYER } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const ItemWrapper = styled.div.attrs(({
  currentOffset,
  itemWidth
}) => ({
  style: {
    display: currentOffset ? 'block' : 'none',
    transform: currentOffset ? `translate(${currentOffset.x}px, ${currentOffset.y}px) translateZ(0)` : 'none',
    maxInlineSize: currentOffset ? itemWidth : 'none'
  }
})).withConfig({
  displayName: "MenuDragLayer__ItemWrapper",
  componentId: "lexgb8-0"
})([""]);
const MenuDragLayer = /*#__PURE__*/forwardRef(({
  item,
  currentOffset,
  isDragging
}, ref) => {
  if (!isDragging) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    children: /*#__PURE__*/_jsx(View, {
      position: "fixed",
      zIndex: EARTH_LAYER,
      insetBlockStart: "0",
      insetInlineStart: "0",
      blockSize: "100%",
      inlineSize: "100%",
      pointerEvents: "none",
      children: /*#__PURE__*/_jsx(ItemWrapper, {
        currentOffset: currentOffset,
        itemWidth: item.width,
        children: /*#__PURE__*/_jsx(MenuRootPreview, {
          id: item.id,
          parentId: item.parentId,
          menuId: item.menuId
        })
      })
    })
  });
});
MenuDragLayer.propTypes = {
  item: PropTypes.object,
  currentOffset: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  isDragging: PropTypes.bool.isRequired
};
export default DragLayer(monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging()
}))(MenuDragLayer);